import loginAuthBanner from '../../distros/marstrade/prime/banners/login-auth-banner.svg'
import logoTitle from '../../distros/marstrade/prime/icons/logo-title.svg'
import logoUnderTitle from '../../distros/marstrade/prime/icons/logo-under-title.svg'

export const assets = Object.freeze({
  loginAuthBanner,
  logoTitle,
  logoTitleFa: logoTitle,
  logoUnderTitle,
  logoWebsite: logoTitle
})
